var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 399.937,
    height: 709.137,
    viewBox: "0 0 399.937 709.137",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-725.096 -140)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.988 21.188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.761,491.836l-28-57.168s-4.667-47.834-23.334-70L278.926,332l-28-28s-29.167-51.334-49-53.668S43.254,307.5,43.254,307.5-2.247,313.332.087,332s12.25,22.191,12.25,22.191L33.921,360l7-1.167L102.756,360l-56,17.5-18.667,5.833s-19.834,8.555-15.75,25.278,15.75,16.723,15.75,16.723l23.334-1.167,24.5-3.5,38.5,18.667L84.089,459.169l2.333,11.667s-7,12.834,0,23.334l7,15.167s11.667,8.167,21-3.5c0,0,5.833-2.333,5.833-7a44.147,44.147,0,0,1,1.167-9.334,16.935,16.935,0,0,1,7-1.167h5.833l15.167,1.167s-1.167,5.833,7,7c0,0,2.333,14,9.334,14,0,0,2.247,8.6,8.123,12.469,0,0,31.544,40.032,56.045,49.366,0,0,29.167,19.834,38.5,19.834l79.335-100.336Z",
    transform: "translate(759.012 158.411)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.353,524.784s-29.1,49.518-30.267,65.852",
    transform: "translate(690.683 78.279)",
    fill: "#090814",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.675,524.784s-14.616,48.351-8.783,74.018",
    transform: "translate(675.378 78.279)",
    fill: "#090814",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.225,510.106,111.249,534.295a39.915,39.915,0,0,1-45.173-33.742L3.673,69.777A39.915,39.915,0,0,1,37.414,24.6L204.39.415a39.914,39.914,0,0,1,45.173,33.742l62.4,430.776a39.914,39.914,0,0,1-33.742,45.173Z",
    transform: "translate(709.85 118.813)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.841,499.94,109.525,524.178a29.95,29.95,0,0,1-33.9-25.318L13.107,67.259a29.95,29.95,0,0,1,25.318-33.9L205.741,9.126a29.95,29.95,0,0,1,33.9,25.318l62.522,431.6a29.95,29.95,0,0,1-25.318,33.9Z",
    transform: "translate(709.378 118.376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.623,46.206l-53.244,7.713a11.249,11.249,0,0,1-3.225-22.266L153.4,23.941a11.249,11.249,0,1,1,3.225,22.266Z",
    transform: "translate(705.526 117.632)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.341,582.846s-10.355-23.77-55.856,40.4-63,89.835-51.334,99.169,45.723,42.95,45.723,42.95h61.467Z",
    transform: "translate(658.704 62.588)",
    fill: "#2b5aa0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.118,581.319S281.45,564.985,277.95,464.65c0,0-9.334-11.667-14-11.667s-5.833-4.667-5.833-4.667-11.667,7-18.667,3.5c0,0-37.334,2.333-45.5-17.5s21-24.5,21-24.5l8.167-1.167,29.167-18.667s12.834-4.667,22.167,5.833l36.167,19.834,30.334,14,15.167,15.167",
    transform: "translate(702.82 117.929)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.367,408.531s-18.725,6.525-26.863,15.513",
    transform: "translate(651.737 112.213)",
    fill: "#090814",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(745.369 261.108) rotate(-9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.268,7.271H3.636A3.636,3.636,0,1,1,3.636,0H23.268a3.636,3.636,0,1,1,0,7.271Z",
    transform: "translate(17.089 0)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.272,
    cy: 3.272,
    r: 3.272,
    transform: "translate(165.789 0.364)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.272,
    cy: 3.272,
    r: 3.272,
    transform: "translate(175.969 0.364)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.272,
    cy: 3.272,
    r: 3.272,
    transform: "translate(186.148 0.364)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.992,53.081H9.089A9.1,9.1,0,0,1,0,43.992V9.089A9.1,9.1,0,0,1,9.089,0h34.9a9.1,9.1,0,0,1,9.089,9.089v34.9a9.1,9.1,0,0,1-9.089,9.089Z",
    transform: "translate(17.088 50.166)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.992,53.081H9.089A9.1,9.1,0,0,1,0,43.992V9.089A9.1,9.1,0,0,1,9.089,0h34.9a9.1,9.1,0,0,1,9.089,9.089v34.9a9.1,9.1,0,0,1-9.089,9.089Z",
    transform: "translate(139.975 50.166)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.992,53.081H9.089A9.1,9.1,0,0,1,0,43.992V9.089A9.1,9.1,0,0,1,9.089,0h34.9a9.1,9.1,0,0,1,9.089,9.089v34.9a9.1,9.1,0,0,1-9.089,9.089Z",
    transform: "translate(78.167 50.166)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.362,0A8.371,8.371,0,0,0,0,8.362v34.9a8.372,8.372,0,0,0,8.362,8.362h34.9a8.372,8.372,0,0,0,8.362-8.362V8.362A8.371,8.371,0,0,0,43.265,0Z",
    transform: "translate(17.815 127.242)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.992,53.081H9.089A9.1,9.1,0,0,1,0,43.992V9.089A9.1,9.1,0,0,1,9.089,0h34.9a9.1,9.1,0,0,1,9.089,9.089v34.9A9.1,9.1,0,0,1,43.992,53.081Z",
    transform: "translate(139.975 126.515)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.992,53.081H9.089A9.1,9.1,0,0,1,0,43.992V9.089A9.1,9.1,0,0,1,9.089,0h34.9a9.1,9.1,0,0,1,9.089,9.089v34.9A9.1,9.1,0,0,1,43.992,53.081Z",
    transform: "translate(78.167 126.515)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.992,53.081H9.089A9.1,9.1,0,0,1,0,43.992V9.089A9.1,9.1,0,0,1,9.089,0h34.9a9.1,9.1,0,0,1,9.089,9.089v34.9a9.1,9.1,0,0,1-9.089,9.089Z",
    transform: "translate(17.088 202.864)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.992,53.081H9.089A9.1,9.1,0,0,1,0,43.992V9.089A9.1,9.1,0,0,1,9.089,0h34.9a9.1,9.1,0,0,1,9.089,9.089v34.9a9.1,9.1,0,0,1-9.089,9.089Z",
    transform: "translate(139.975 202.864)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.992,53.081H9.089A9.1,9.1,0,0,1,0,43.992V9.089A9.1,9.1,0,0,1,9.089,0h34.9a9.1,9.1,0,0,1,9.089,9.089v34.9a9.1,9.1,0,0,1-9.089,9.089Z",
    transform: "translate(78.167 202.864)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 73.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.594,97.436H13.186A13.2,13.2,0,0,1,0,84.25V13.186A13.2,13.2,0,0,1,13.186,0H192.594a13.2,13.2,0,0,1,13.186,13.186V84.25A13.2,13.2,0,0,1,192.594,97.436Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.594,97.436H13.186A13.2,13.2,0,0,1,0,84.25V13.186A13.2,13.2,0,0,1,13.186,0H192.594a13.2,13.2,0,0,1,13.186,13.186V84.25A13.2,13.2,0,0,1,192.594,97.436ZM47.859,1.454a46.4,46.4,0,0,0-46.4,46.4V84.25A11.731,11.731,0,0,0,13.186,95.982H192.594A11.731,11.731,0,0,0,204.325,84.25V13.186A11.731,11.731,0,0,0,192.594,1.454Z",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.075,2.194.713,1.431A.715.715,0,0,1,.718,0L66.08.763a.715.715,0,1,1-.005,1.43Z",
    transform: "translate(24.62 32.204)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.523,2.194.713,1.43A.715.715,0,0,1,.718,0l98.81.763a.715.715,0,1,1-.005,1.43Z",
    transform: "translate(24.62 43.838)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.27,
    cy: 15.27,
    r: 15.27,
    transform: "translate(148.802 24.541)",
    fill: "#2b5aa0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.771,12.766,5.385,0,0,12.766l4.658-1.979v7.727H6.112V10.787Z",
    transform: "translate(158.687 30.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.516,0H1.818a1.818,1.818,0,1,0,0,3.636h152.7a1.818,1.818,0,1,0,0-3.636Z",
    transform: "translate(24.825 69.26)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.074,0V3.636H1.818A1.818,1.818,0,1,1,1.818,0Z",
    transform: "translate(24.825 69.26)",
    fill: "#2b5aa0"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.469d653ffaf94c0528351c17af302da0.svg";
export { ForwardRef as ReactComponent };